import { Box, TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { isValid } from 'date-fns';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import { Timezone } from '../../types';
import { dateTimeFieldFormat, is24HourClock } from '../../utils/formatTime';
import { validateTimeInFuture } from '../../utils/parseTime';

export interface EndTimeFieldProps {
  control: Control<any>;
  disabled?: boolean;
  name: string;
  timezone?: Timezone;
}

const EndTimeField = ({ control, disabled, name, timezone }: EndTimeFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
    rules: {
      required: 'Please provide an end time',
      validate: {
        date: v => isValid(v) || 'This is no valid date',
        minDateTime: v => validateTimeInFuture(v, timezone),
      },
    },
  });

  return (
    <Box
      {...field}
      component={DateTimePicker}
      disabled={disabled}
      disableMaskedInput
      disablePast
      ampm={!is24HourClock}
      inputFormat={dateTimeFieldFormat}
      label="To date and time"
      renderInput={props => (
        <TextField {...props} error={!disabled && !!error} helperText={!disabled && error?.message} required />
      )}
      sx={{ flex: 1 }}
    />
  );
};

export default EndTimeField;
